import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-qr-zoom',
    templateUrl: './qr-zoom.component.html',
    styleUrls: ['./qr-zoom.component.css'],
    standalone: false
})
export class QrZoomComponent {
  @Input() src: string;
  @Input() showZoom: boolean;
  @Output() showZoomEvent = new EventEmitter<boolean>();

  constructor() { }

  setZoom(show: boolean) {
    this.showZoom = show;
    this.showZoomEvent.emit(show);
  }
}


